import React from 'react';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from 'react-helmet-async';
import AppWithI18n from "@/components/AppWithI18n";
import { ProviderChain } from "@/components/SafeProviders";
import { OfflineBanner } from "@/components/OfflineBanner";
import { SmartNotificationManager } from "@/components/SmartNotificationManager";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 1,
      refetchOnWindowFocus: false,
      refetchOnMount: false
    },
    mutations: {
      retry: 1
    }
  },
});

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ProviderChain>
            <Toaster />
            <Sonner />
            <OfflineBanner />
            <SmartNotificationManager />
            <AppWithI18n />
          </ProviderChain>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
